export const xAxisStyle = (value)=>{
    return {
        textStyle: {
          lineHeight: 16
        },
        value
    }
}
